import { AstraTooltip, astraTwMerge } from '~/astra'
import { ButtonTag } from '~/components'
import { useStore } from '~/store/store'
import { PractitionerStatusDefinition, usePractitionerStatusDefinitions } from '~/storm'

export type StatusDefinitionListProps = {
    assignedStatuses: string[]
    onStatusClick?: (status: PractitionerStatusDefinition) => void
}

export const StatusDefinitionList = ({ assignedStatuses, onStatusClick: onStatusClick }: StatusDefinitionListProps) => {
    const departmentKey = useStore(state => state.appFilters.departmentKey)
    const relevantStatuses = usePractitionerStatusDefinitions({
        where: departmentKey === 'all' ? undefined : { OR: [{ departments: { none: {} } }, { departments: { any: { id: departmentKey } } }] },
    })

    const isStatusAssigned = (status: { code: string }) => assignedStatuses.some(assignedStatus => assignedStatus === status.code)

    return (
        <div className="grid grid-cols-3 gap-2">
            {relevantStatuses.map(status => (
                <AstraTooltip key={status.code} tooltipContent={status.title}>
                    <ButtonTag
                        className={astraTwMerge('flex h-[20px] min-w-10 items-center', isStatusAssigned(status) ? 'border border-brand-ring' : '')}
                        key={status.code}
                        colorType={status.color}
                        label={status.label}
                        fillType="all"
                        onClick={() => onStatusClick?.(status)}
                    />
                </AstraTooltip>
            ))}
        </div>
    )
}
